import { CheckCircle2, ChevronRight, CircleAlert } from "lucide-react";
import { getOrganizationSetupItems, getSetupProgress } from "./organizationSetup";

const SetupOverviewTab = ({
  organization,
  orgDetails,
  stripeConnected,
  admins,
  documents,
  onOpenSection,
}) => {
  const items = getOrganizationSetupItems({
    organization,
    details: orgDetails,
    stripeConnected,
    administrators: admins,
    documents,
  });
  const progress = getSetupProgress(items);

  return (
    <div className="organization-setup-overview" data-testid="organization-setup-overview">
      <header className="settings-readiness-strip">
        <div className="settings-readiness-copy">
          <h2>Organization readiness</h2>
          <p>Complete the operational essentials, then use the detailed settings for ongoing changes.</p>
        </div>
        <div className="settings-readiness-progress">
          <span>{progress.complete} of {progress.total} ready</span>
          <div role="progressbar" aria-label="Organization readiness" aria-valuemin={0} aria-valuemax={100} aria-valuenow={progress.percent} aria-valuetext={`${progress.percent}% setup complete`}>
            <span style={{ width: `${progress.percent}%` }} />
          </div>
          <strong>{progress.percent}%</strong>
        </div>
      </header>


      <section className="organization-setup-checklist" aria-label="Organization setup checklist">
        {items.map((item) => (
          <button key={item.id} type="button" onClick={() => onOpenSection(item.id)}>
            {item.complete ? <CheckCircle2 className="is-complete" /> : <CircleAlert className="needs-attention" />}
            <span>
              <strong>{item.label}</strong>
              <small>{item.description}</small>
            </span>
            <em>{item.complete ? "Ready" : "Review"}</em>
            <ChevronRight />
          </button>
        ))}
      </section>
      <details className="settings-access-disclosure">
        <summary>Role-aware setup</summary>
        <p>Access remains controlled by existing admin permissions. Payment and integration credentials are never displayed here.</p>
      </details>
    </div>
  );
};

export default SetupOverviewTab;
